import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import BackupBrowser from "./backup-browser"

export default function BackupPage() {
  return (
    <SidePanelLayout
      menuName="AdminBackupMenu"
      tabs={{
        AdminBackupManagement: BackupBrowser,
      }}
    />
  )
}
